import type { ChessColor } from "./base-model";
import type {
    ChessGame,
    ChessGameSource,
    ChessSimpleResult,
} from "./chess-game-model";

export type ChessGameLite = {
    id: string;
    username: string;
    slug: string;
    endTimeUnix: number;
    source: ChessGameSource;
    collectionId: string;
    playerColor: ChessColor;
    playerResult: ChessSimpleResult;
    whiteUsername: string;
    blackUsername: string;
    timeControl: string;
    openingFamily: string;
};

const from = (game: ChessGame): ChessGameLite => ({
    id: game.id,
    slug: game.slug,
    username: game.username,
    endTimeUnix: game.endTimeUnix,
    source: game.source,
    collectionId: game.collectionId,
    playerColor: game.playerColor,
    playerResult: game.playerResult,
    whiteUsername: game.white.username,
    blackUsername: game.black.username,
    timeControl: game.time.control,
    openingFamily: game.opening.name.family,
});

export const ChessGameLite = { from };
